// 所有特效都會放在這邊
const initState = {
  couponData: [],

};

export function couponState(state = initState, action) {
  switch (action.type) {
    case 'UPDATE_COUPON_LIST_DATA': {
      return {
        ...state,
        couponData: action.payload,
      };
    }

    default:
      return state;
  }
}

export default couponState;
